export default __webpack_public_path__ + "static/media/household-floor-plan-4-1.25bc4d57.png";